import React from 'react'
import loadingGif from '../images/gif/loading-arrow.gif'

export default function Laoding() {
    return (
        <div className="loading">
            <h4>Rooms data loading...</h4>
            <img src={loadingGif} alt="" />
        </div>
    )
}
